import React, { useEffect, useState } from "react";

import Preloader from "~/components/Preloader";
import { useDealerData } from "~/app/Context/DealerContext";
import { useDataMain } from "~/entity/Dealer";
import { useGetSubscriptionsList } from "~/entity/Ivideon";
import {
  DealersLocationItem,
  useGetDealersLocationItemQuery,
} from "~/schemas/generated/graphql";

import FormFilter from "./FormFilter";
import { mapToOptions } from "./helper";
import {
  DealerInfoIProps,
  OptionsGroupIProps,
  ParseForServerResultIProps,
} from "./schema/types";
import { getAnalyticsReportIProps } from "~/entity/Ivideon/hooks/useGetAnalyticaReport";

interface FilterSummaryIProps {
  setParamsFilter: (props: ParseForServerResultIProps) => void;
  getAnalyticsReport: (data: getAnalyticsReportIProps) => void;
  type: "face" | "cars";
}

const FilterSummary = ({
  setParamsFilter,
  getAnalyticsReport,
  type,
}: FilterSummaryIProps) => {
  const [dealerInfo, setDealerInfo] = useState<DealerInfoIProps | null>(null);
  const { data: dealershipsForSelect, isLoading } = useGetSubscriptionsList();
  const { DealerId } = useDealerData();

  const { getDataDealerMain } = useDataMain({ id: DealerId });

  useEffect(() => {
    if (getDataDealerMain.data?.dealer && !dealerInfo) {
      const info = getDataDealerMain.data.dealer;
      setDealerInfo({
        dealer: { label: info.dealerName, value: info.id },
        city: { label: info.city.toLocaleUpperCase(), value: info.city.toLocaleUpperCase() },
        subject: null,
        FO: { label: info.FO, value: info.FO },
        country: { label: info.country, value: info.country },
      });
    }
  }, [getDataDealerMain.data?.dealer, dealerInfo]);

  const language = localStorage.getItem("language");
  const isEn = language === "en";

  const dealerCity = useGetDealersLocationItemQuery({
    variables: { item: DealersLocationItem.City },
  });
  const dealerSubject = useGetDealersLocationItemQuery({
    variables: { item: DealersLocationItem.Subject },
  });
  const dealerFO = useGetDealersLocationItemQuery({
    variables: { item: DealersLocationItem.Fo },
  });
  const dealerCountry = useGetDealersLocationItemQuery({
    variables: { item: DealersLocationItem.Country },
  });

  const options: OptionsGroupIProps = {
    dealer: dealershipsForSelect,
    city: mapToOptions(dealerCity, isEn),
    subject: mapToOptions(dealerSubject, isEn),
    FO: mapToOptions(dealerFO, isEn),
    country: mapToOptions(dealerCountry, isEn),
  };

  return (
    <>
      {dealerInfo ? (
        <FormFilter
          options={options}
          setParamsFilter={setParamsFilter}
          dealerInfo={dealerInfo}
          getAnalyticsReport={getAnalyticsReport}
          type={type}
        />
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default FilterSummary;
